import * as React from "react";
import { useCallback } from "react";
import { useTranslation } from "react-i18next";
import { Button } from "components/bootstrap";
import useSelectedEntities from "components/common/EntityDataTable/hooks/useSelectedEntities";
function ClearSelection() {
  const { t } = useTranslation("enterprise_illuminate");
  const { selectedEntities, setSelectedEntities } = useSelectedEntities();
  const cancelEntitySelection = useCallback(() => setSelectedEntities([]), [setSelectedEntities]);
  return selectedEntities.length > 0 ? /* @__PURE__ */ React.createElement(Button, { bsSize: "sm", onClick: cancelEntitySelection }, t("clear_selection.clear_all")) : null;
}
export default ClearSelection;
